import { SoilTexture } from '../../resources/plots';
export { default as useCanCreateMorePlots } from './useCanCreateMorePlots';
export { default as useCapacitiveEquationOptions } from './useCapacitiveEquationOptions';
export { default as useIrrigationTypesOptions } from './useIrrigationTypesOptions';
export * from './usePlotActions';
export { default as useToggleIsFavorite } from './useToggleIsFavorite';
export * from './useUpdateOrgPlotDevices';
export { default as usePlotsLinkedToDeviceActions } from './usePlotsLinkedToDeviceActions';
export { default as usePlotUniverses } from './usePlotUniverses';
export { usePlotMetaOptions } from './usePlotMetaOptions';
// arbitrary sorted soil textures to match numbering on Texture Triangle
export const ORDERED_SOIL_TEXTURES = [
    SoilTexture.clay,
    SoilTexture.siltClay,
    SoilTexture.siltyClayLoam,
    SoilTexture.siltLoam,
    SoilTexture.silt,
    SoilTexture.clayLoam,
    SoilTexture.sandyClay,
    SoilTexture.sandyClayLoam,
    SoilTexture.loam,
    SoilTexture.sandyLoam,
    SoilTexture.loamySand,
    SoilTexture.sand
];
